{ useI18n } = require 'lib/react_utils'
{ isAcpFeaturesOn } = require 'stores/utils/etd_template_helper'
{
  allOutcomesUseMinimallyImportantDifferences,
  formatOutcomeDecimal,
  formatOutcomeThresholdValue,
  getOutcomeField,
  getOutcomesList
} = require 'lib/outcomes_helper'

OutcomesThresholdTable = (props) ->
  i18n = useI18n("es:outcome")
  { outcomes } = props
  outcomesList = getOutcomesList outcomes
  useMinimallyImportantDifferences = allOutcomesUseMinimallyImportantDifferences outcomesList
  thresholdColSpan = if useMinimallyImportantDifferences then 1 else 3
  thresholdHeaderLabel = if useMinimallyImportantDifferences
    i18n 'minimally_important_differences'
  else
    i18n 'magnitude_of_effect_thresholds'

  i18nKeyPrefix = if isAcpFeaturesOn() then 'acp_' else ''

  <table className="etd-outcomes-thresholds-table">
    <thead>
      <tr>
        <th rowSpan="2">{i18n 'prioritized_outcomes'}</th>
        <th colSpan="1">{i18n 'outcome_importance'}</th>
        <th colSpan={thresholdColSpan}>{thresholdHeaderLabel}</th>
      </tr>
      <tr>
        <th>{i18n 'health_utility_values'}</th>
        {if useMinimallyImportantDifferences
          <th>{i18n 'threshold'}</th>
        else
          [
            <th key="thresholdT1">{i18n "#{i18nKeyPrefix}trivial_small_effect"}</th>
            <th key="thresholdT2">{i18n "#{i18nKeyPrefix}small_moderate_effect"}</th>
            <th key="thresholdT3">{i18n "#{i18nKeyPrefix}moderate_large_effect"}</th>
          ]
        }
      </tr>
    </thead>
    <tbody>
      {_.map outcomesList, (outcome, idx) ->
        utility = getOutcomeField(outcome, 'utilityValue', 0)

        <tr key={getOutcomeField(outcome, '_id', idx)}>
          <td>{getOutcomeField outcome, 'name'}</td>
          <td>{formatOutcomeDecimal(utility, 3)}</td>
          <td>{formatOutcomeThresholdValue outcome, getOutcomeField(outcome, 'thresholdT1')}</td>
          {unless useMinimallyImportantDifferences
            [
              <td key="thresholdT2">
                {formatOutcomeThresholdValue outcome, getOutcomeField(outcome, 'thresholdT2')}
              </td>
              <td key="thresholdT3">
                {formatOutcomeThresholdValue outcome, getOutcomeField(outcome, 'thresholdT3')}
              </td>
            ]
          }
        </tr>
      }
    </tbody>
  </table>

OutcomesThresholdTable.propTypes =
  cellLabel: PropTypes.string
  inAutoMode: PropTypes.bool
  isEditing: PropTypes.bool
  outcomes: PropTypes.oneOfType([
    PropTypes.instanceOf(Immutable.List)
    PropTypes.array
  ]).isRequired
  showContentModeSwitchModal: PropTypes.func

module.exports = OutcomesThresholdTable
